import { IS_ADMIN_APP } from "../utils/stateTypes";


// Storage can be unavailable (private browsing, blocked site data) so every access is guarded - the member then
// just stays logged in for this visit only
const storage = () => {
  try {
    return window.localStorage;
  }
  catch (e) {
    return null;
  }
};

/* ------------------------ AUTH ------------------------ */
// The admin's login is kept apart from a member's, so logging in to one doesn't log you in or out of the other

const TOKEN_KEY = IS_ADMIN_APP ? "admin-jwt" : "jwt";
const REFRESH_KEY = IS_ADMIN_APP ? "admin-refresh" : "refresh";

export const storeTokens = async (token, refreshToken) => {
  try {
    storage().setItem(TOKEN_KEY, token);
    storage().setItem(REFRESH_KEY, refreshToken);
  }
  catch (e) {
    /* Not critical */
  }
};

export const clearTokens = async () => {
  try {
    storage().removeItem(TOKEN_KEY);
    storage().removeItem(REFRESH_KEY);
  }
  catch (e) {
    /* Not critical */
  }
};

export const getToken = async () => {
  try {
    return storage().getItem(TOKEN_KEY);
  }
  catch (e) {
    return null;
  }
};

export const getRefreshToken = async () => {
  try {
    return storage().getItem(REFRESH_KEY);
  }
  catch (e) {
    return null;
  }
};

/* ------------------------ PRICING PREFERENCES ------------------------ */
// Rand (PayFast) or dollars (PayPal), and monthly or annual

export const loadPricingPrefs = () => {
  try {
    return JSON.parse(storage().getItem("pricing")) || null;
  }
  catch (e) {
    return null;
  }
};

export const savePricingPrefs = (prefs) => {
  try {
    storage().setItem("pricing", JSON.stringify(prefs));
  }
  catch (e) {
    /* Not critical */
  }
};

/* ------------------------ LIBRARY FILTERS ------------------------ */
// Remembers the member's last filters per library

export const loadFilters = (slug) => {
  try {
    return JSON.parse(storage().getItem(`filters-${slug}`)) || null;
  }
  catch (e) {
    return null;
  }
};

export const saveFilters = (slug, filters) => {
  try {
    storage().setItem(`filters-${slug}`, JSON.stringify(filters));
  }
  catch (e) {
    /* Not critical */
  }
};
